// Determine site mode from hostname (mirrors roleAccess pattern from main app)
// Override with ?mode=public or ?mode=dev in the URL — persists via localStorage.
// Use ?mode=reset to clear the override and return to automatic hostname detection.
export const getSiteMode = () => {
    const params = new URLSearchParams(window.location.search);
    const override = params.get("mode");
    if (override === "reset") {
        localStorage.removeItem("ferabio_site_mode");
    } else if (override === "public" || override === "dev") {
        localStorage.setItem("ferabio_site_mode", override);
    }
    const stored = localStorage.getItem("ferabio_site_mode");
    if (stored === "public" || stored === "dev") return stored;
    const hostname = window.location.hostname;
    return ["localhost", "127.0.0.1"].includes(hostname) ? "dev" : "public";
};
